import styled from 'styled-components';

export const Body = styled.div`
    overflow-y: auto;
    max-height: 640px;
    padding: 16px 32px;
`;
